import { render, staticRenderFns } from "./VipGoodList.vue?vue&type=template&id=77724ef5&"
import script from "./VipGoodList.vue?vue&type=script&lang=js&"
export * from "./VipGoodList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports